import { CloneMenuAction, DeleteMenuAction, EmbedMenuAction, PreviewMenuAction, UnpublishMenuAction, RunAbTestMenuAction, CreateVariationMenuAction, SummarizeCtaAction } from '.';
import { useSelector } from 'react-redux';
import { isAbContentState, getIsPublished } from 'web-interactives-dashboard-ui/utils/webInteractiveStateUtils';
import { getHasAbTestingGate, getHasAiSummarizeGate, getHasAiVariationAccess } from '../../../selectors/auth';
import { List } from 'foundations-components/transitional/components/List';
import { RenderWhen } from '../../../utils/RenderWhen';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InteractiveMenuOptions = ({
  containerType,
  contentId,
  name,
  objectId,
  state,
  isSmart,
  isActiveAbTest,
  isPersonalized,
  context = 'listing'
}) => {
  const hasAiVariationAccess = useSelector(getHasAiVariationAccess);
  const hasAbTestingGate = useSelector(getHasAbTestingGate);
  const hasAiSummarizeGate = useSelector(getHasAiSummarizeGate);
  const isAbTest = isAbContentState(state);
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [/*#__PURE__*/_jsx(RenderWhen, {
      when: context === 'details' && hasAiSummarizeGate,
      children: /*#__PURE__*/_jsx(SummarizeCtaAction, {
        interactiveId: objectId,
        name: name
      })
    }), /*#__PURE__*/_jsx(CloneMenuAction, {
      interactiveId: contentId,
      name: name,
      isAbTest: isAbTest
    }), /*#__PURE__*/_jsx(PreviewMenuAction, {
      containerType: containerType,
      interactiveId: contentId
    }), /*#__PURE__*/_jsx(EmbedMenuAction, {
      containerType: containerType,
      interactiveId: contentId,
      interactiveState: state
    }), getIsPublished(state) && /*#__PURE__*/_jsx(UnpublishMenuAction, {
      interactiveId: contentId
    }), /*#__PURE__*/_jsx(DeleteMenuAction, {
      interactiveId: contentId,
      name: name,
      objectId: objectId
    }), !isActiveAbTest && hasAbTestingGate && /*#__PURE__*/_jsx(RunAbTestMenuAction, {
      interactiveId: contentId,
      name: name,
      isSmart: isSmart,
      isPersonalized: isPersonalized
    }), hasAiVariationAccess && /*#__PURE__*/_jsx(CreateVariationMenuAction, {
      contentId: contentId
    })]
  });
};